module.exports = __webpack_public_path__ + "img/Logo-02.619caac1.png";